import { create } from 'zustand';
import i18n from 'i18n';
import { GetFooterContentResponse, ResourceApi, RestApiError, StatusCodeEnum } from '@shared/api';
import type { BaseReturn } from '@shared/types';

interface UseFooterContentStore {
  loading: boolean;
  data: GetFooterContentResponse[] | null;
  error?: string | null;
  getFooterContent: () => Promise<BaseReturn<[] | null>>;
  clear: () => void;
}

export const useFooterContentStore = create<UseFooterContentStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getFooterContent: async () => {
    try {
      set({ loading: true, data: null, error: null });
      const result = await ResourceApi.getFooterContent();
      set({ loading: false, data: result ?? [] });
      return { loading: false, data: result ?? [] };
    } catch (e) {
      const restError = e as RestApiError;

      let errorMessage = 'Something went wrong, try again';
      switch (restError?.status) {
        case StatusCodeEnum.API_ERROR_UNAUTHORIZED:
          errorMessage = 'Your session was expired, sign in again';
          break;
      }

      const error = i18n.t(`errors.api.${errorMessage}`, errorMessage);
      set({ loading: false, data: null, error });
      return { loading: false, data: null, error };
    }
  },

  clear: () => set({ loading: false, data: null, error: null }),
}));
